module.exports = __webpack_public_path__ + "static/media/appointment_p1_1.db696a40.png";